module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "elevation": "1"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": "dense"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-700 font-size-12"
  }, [_vm._v(" Nuevo ticket de garantia")]), _c('v-spacer')], 1), _c('v-divider'), _c('div', {
    staticClass: "box-new-ticket pa-3"
  }, [_c('v-slide-group', {
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.ticket.comproAqui),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "comproAqui", $$v)
      },
      expression: "ticket.comproAqui"
    }
  }, _vm._l((_vm.acciones), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center pa-2",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "60",
              "dark": active,
              "width": "140"
            },
            on: {
              "click": toggle
            }
          }, [_c('span', {
            staticClass: "font-size-13 font-weight-700"
          }, [_vm._v(_vm._s(n.name))])])]
        }
      }], null, true)
    })
  }), 1), (_vm.ticket.comproAqui === 1) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "hide-details",
      "label": "¿Tu equipo se encuentra en garantia?"
    },
    model: {
      value: (_vm.ticket.sigueEnGarantia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "sigueEnGarantia", $$v)
      },
      expression: "ticket.sigueEnGarantia"
    }
  })], 1) : _vm._e(), (_vm.ticket.comproAqui && _vm.ticket.sigueEnGarantia) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "icon": "info",
      "text": "text",
      "dense": "dense",
      "type": "info"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-13 font-weight-700"
  }, [_vm._v("Es requerido adjuntar la Boleta o Factura para verificar la garantia, use la opción de adjuntar que se encuentra en la parte inferior de este formulario.")])])])], 1) : _vm._e(), (_vm.ticket.comproAqui === 1) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('v-text-field', {
    ref: "numeroFactura",
    staticClass: "mt-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "type": "text",
      "label": ("Numero de boleta o factura " + (!_vm.ticket.sigueEnGarantia ? '(Opcional)' : ''))
    },
    model: {
      value: (_vm.ticket.numeroFactura),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "numeroFactura", $$v)
      },
      expression: "ticket.numeroFactura"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mt-2"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" ¿Que tipo de equipo posee?")]), _c('v-select', {
    staticClass: "mt-1",
    attrs: {
      "loading": _vm.isGettingTiposEquipo,
      "dense": "dense",
      "hide-details": "hide-details",
      "items": _vm.tiposEquipo,
      "return-object": "return-object",
      "item-text": "descripcion",
      "placeholder": "Listados de tipos de equipos",
      "solo": "solo"
    },
    on: {
      "change": _vm.fetchFallas
    },
    model: {
      value: (_vm.ticket.tipoEquipo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "tipoEquipo", $$v)
      },
      expression: "ticket.tipoEquipo"
    }
  })], 1), _c('div', {
    staticClass: "pt-2"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" ¿Que esta fallando?")]), _c('v-select', {
    staticClass: "mt-2",
    attrs: {
      "loading": _vm.isGettingFallas,
      "dense": "dense",
      "hide-details": "hide-details",
      "return-object": "return-object",
      "item-value": "codigoFallaGeneral",
      "item-text": "descripcionFallaGeneral",
      "items": _vm.fallas,
      "placeholder": ("Listado de fallas para la serie " + (_vm.ticket.serie)),
      "solo": "solo"
    },
    model: {
      value: (_vm.ticket.falla),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "falla", $$v)
      },
      expression: "ticket.falla"
    }
  }), _c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "icon": "info",
      "outlined": "outlined",
      "text": "",
      "dense": "dense",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-14 font-weight-700"
  }, [_vm._v("Explicanos un poco más de la falla de tu equipo")]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v(" Ejemplos")]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" - La parte superior izquierda de la hoja sale manchada de rojo")]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" - Si el equipo mostrara un código de error, por favor ingreselo aquí")])])]), _c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "placeholder": "Comentario adicional sobre la falla (opcional)",
      "solo": "solo",
      "dense": "dense",
      "rows": "3"
    },
    model: {
      value: (_vm.ticket.comentarioFalla),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "comentarioFalla", $$v)
      },
      expression: "ticket.comentarioFalla"
    }
  })], 1), _c('div', {
    staticClass: "d-flex my-4 mx-2",
    class: _vm.isMovil && 'fd-column'
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-select', {
    attrs: {
      "dense": "dense",
      "items": _vm.marcas,
      "label": "Marca del equipo (Opcional)",
      "item-text": "descripcion",
      "item-value": "descripcion",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.ticket.marca),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "marca", $$v)
      },
      expression: "ticket.marca"
    }
  })], 1), (_vm.ticket.tipo === 'garantia') ? _c('div', {
    staticClass: "flex-1",
    class: !_vm.isMovil && 'px-6'
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Modelo del equipo o factura (Opcional)"
    },
    model: {
      value: (_vm.ticket.modelo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "modelo", $$v)
      },
      expression: "ticket.modelo"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipo === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Serie del equipo o factura (Opcional)"
    },
    model: {
      value: (_vm.ticket.serie),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "serie", $$v)
      },
      expression: "ticket.serie"
    }
  })], 1) : _vm._e()]), (_vm.ticket.tipo === 'garantia') ? _c('v-row', {
    staticClass: "my-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "Ubigeo",
      "type": "number",
      "loading": _vm.isLoadingUbigeos,
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchUbigeos(true)
      }
    },
    model: {
      value: (_vm.ticket.ubigeo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "ubigeo", $$v)
      },
      expression: "ticket.ubigeo"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "primary",
            "small": "small",
            "disabled": _vm.isLoadingUbigeos || !_vm.ticket.ubigeo
          },
          on: {
            "click": function($event) {
              return _vm.fetchUbigeos(true)
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("search")])], 1)]
      }
    }], null, false, 3378669583)
  }, [_c('small', [_vm._v("Obtener ubigeo")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.departamentos,
      "dense": "",
      "label": "Departamento",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('departamento')
      }
    },
    model: {
      value: (_vm.ticket.departamento),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "departamento", $$v)
      },
      expression: "ticket.departamento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.provincias,
      "dense": "",
      "label": "Provincia",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('provincia')
      }
    },
    model: {
      value: (_vm.ticket.provincia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "provincia", $$v)
      },
      expression: "ticket.provincia"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.distritos,
      "dense": "",
      "label": "Distrito",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('distrito')
      }
    },
    model: {
      value: (_vm.ticket.distrito),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "distrito", $$v)
      },
      expression: "ticket.distrito"
    }
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "pt-0"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" ¿Alguna observación adicional?")]), _c('v-textarea', {
    staticClass: "ma-1 mt-3",
    attrs: {
      "hide-details": "hide-details",
      "placeholder": "Comentario general  (Opcional)",
      "solo": "solo",
      "dense": "dense",
      "rows": "3"
    },
    model: {
      value: (_vm.ticket.comentarioGeneral),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "comentarioGeneral", $$v)
      },
      expression: "ticket.comentarioGeneral"
    }
  })], 1), (_vm.ticket.tipo === 'garantia') ? _c('div', {
    staticClass: "pt-0"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" Adjuntar sustento a la solicitud (Boleta, Guia o Factura de compra)")]), _c('adjuntar-archivos', {
    ref: "archivos",
    attrs: {
      "mode-insert": "mode-insert"
    }
  })], 1) : _vm._e()], 1), _c('v-divider'), _c('div', {
    staticClass: "d-flex pa-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": _vm.fetchGuardarTicket
    }
  }, [_vm._v("Generar ticket")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b915c9","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/New_Ticket_View.vue
// module id = 503
// module chunks = 1